import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'

export default {
  async getDecisionQueue({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'decisionQueue', () =>
      http.get('dispatch/DecisionQueue')
    )
    commit(types.SET_QUEUE, r.data)
  },
  async getDecisionYears({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'decisionYears', () =>
      http.get('dispatch/DecisionYears')
    )
    commit(types.SET_YEARS, r.data)
  },
  async getDecisionMakes({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'decisionMakes', () =>
      http.get('dispatch/DecisionMakes')
    )
    commit(types.SET_MAKES, r.data)
  },
  async getDecisionLanguages({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'decisionLanguages', () =>
      http.get('dispatch/DecisionLanguages')
    )
    commit(types.SET_LANGUAGES, r.data)
  },
  async processDecisionTree({ commit, dispatch }, scenario) {
    const r = await startLoading(dispatch, 'processTree', () =>
      http.get(`dispatch/DispatchTeam`, {
        params: scenario
      })
    )
    commit(types.SET_ANSWER, r.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/dispatch/actions.js